// Environment-based configuration

// https://api-droplet.vyfoo.com/api/admin
// https://staffapi.shunyape.com/api/admin

const getBaseURL = () => {
  // Check for explicit environment variable first
  if (process.env.REACT_APP_API_URL) {
    console.log('🔗 Using API URL from environment:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }

  // Auto-detect based on current host
  if (typeof window !== 'undefined') {
    const currentHost = window.location.hostname;

    if (currentHost.includes('vyfoo.com')) {
      // const apiUrl = "https://staffapi.shunyape.com/api/admin";
      const apiUrl = "https://api-droplet.vyfoo.com/api/admin";

      console.log('🔗 Auto-detected vyfoo.com environment, using:', apiUrl);
      return apiUrl;
    }

    if (currentHost === 'localhost') {
      // const apiUrl = "http://localhost:3015/api/admin";
      const apiUrl = "https://api-droplet.vyfoo.com/api/admin";
      // const apiUrl = "https://staffapi.shunyape.com/api/admin";
      console.log('🔗 Auto-detected localhost environment, using:', apiUrl);
      return apiUrl;
    }
  }

  // Fallback based on NODE_ENV
  if (process.env.NODE_ENV === 'production') {
    // return "https://staffapi.shunyape.com/api/admin";
    return "https://api-droplet.vyfoo.com/api/admin";

  } else {
    return "http://localhost:3015/api/admin";
  }
};

export const NewBaseURL = getBaseURL();




// Add debugging information
console.log(`🚀 [${new Date().toISOString()}] API Configuration:`, {
  baseURL: NewBaseURL,
  environment: process.env.NODE_ENV,
  host: typeof window !== 'undefined' ? window.location.hostname : 'SSR',
  userAgent: typeof navigator !== 'undefined' ? navigator.userAgent.substring(0, 50) : 'N/A'
});

// Network connectivity checker
export const checkAPIConnectivity = async () => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

    const response = await fetch(`${NewBaseURL}/health-check`, {
      method: 'GET',
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
      }
    });

    clearTimeout(timeoutId);

    if (response.ok) {
      console.log('✅ API connectivity check passed');
      return true;
    } else {
      console.warn('⚠️ API responded but with non-200 status:', response.status);
      return false;
    }
  } catch (error) {
    console.error('❌ API connectivity check failed:', error.message);
    return false;
  }
};






export const LoginURL = `${NewBaseURL}/login`;
export const checkEmailURL = `${NewBaseURL}/checkAuthEmail`;
export const countryList = `${NewBaseURL}/countryList`;


export const SignupURL = `${NewBaseURL}/signup`;
export const globalSignup = `${NewBaseURL}/globalSignup`;



export const sendMobileVerificationCodeURL = `${NewBaseURL}/sendMobileVerificationCode`;
export const checkMobileVerificationCodeURL = `${NewBaseURL}/checkMobileVerificationCode`;


export const GetStateListURL = `${NewBaseURL}/getState`;
export const GetCityListURL = `${NewBaseURL}/getCity`;
export const SendOTPURL = `${NewBaseURL}/sendOtp`;
export const VerifyOTPURL = `${NewBaseURL}/verify_otp`;
export const GetUserDetailsURL = `${NewBaseURL}/getProfile`;
export const UpdateUserDetailsURL = `${NewBaseURL}/saveProfile`;
export const UpdateFooderPasswordURL = `${NewBaseURL}/updatePassword`;
export const UpdateStaffProfilePasswordURL = `${NewBaseURL}/updateStaffProfilePassword`;
export const checkAuthEmailVerified = `${NewBaseURL}/checkAuthEmailVerified`;
export const sendOtpAuthEmailVerification = `${NewBaseURL}/sendOtpAuthEmailVerification`;
export const verifyOtpAuthEmailVerification = `${NewBaseURL}/verifyOtpAuthEmailVerification`;
export const getFooderCountryURL = `${NewBaseURL}/getFooderCountry`;
export const updateFooderCountryURL = `${NewBaseURL}/updateFooderCountry`;








export const UpdateFooderStatusURL = `${NewBaseURL}/updateFoodersStatus`;
export const ForgotURL = `${NewBaseURL}/forgotPassword`;
export const ResetURL = `${NewBaseURL}/resetPassword`;
/***************************************************************************************/
export const GetCategoryMenuURL = `${NewBaseURL}/getCategory`;
export const SearchCategoryMenuURL = `${NewBaseURL}/searchMenu`;
export const UpdateCategoryMenuStatusURL = `${NewBaseURL}/updateCategoryStatus`;
export const AddCategoryMenuURL = `${NewBaseURL}/saveCategory`;
export const GetEditCategoryMenuURL = `${NewBaseURL}/getSingleCategoryList`;
export const EditCategoryMenuURL = `${NewBaseURL}/updateCategory`;
export const DeleteCategoryMenuURL = `${NewBaseURL}/deleteCategory`;
/***************************************************************************************/
export const GetDishesProductsURL = `${NewBaseURL}/getProduct`;
export const GetAllProductsNameURL = `${NewBaseURL}/GetAllProductsName`;

export const SearchDishesProductsURL = `${NewBaseURL}/searchProduct`;
export const UpdateDishesProductsStatusURL = `${NewBaseURL}/updateProductStatus`;
export const RemoveProductImage = `${NewBaseURL}/removeProductImage`;



export const GetCategoryMenuListURL = `${NewBaseURL}/getCategoryNameList`;
export const AddDishesProductURL = `${NewBaseURL}/saveProduct`;
export const UploadDishesProductPicURL = `${NewBaseURL}/uploadProduct`;
export const DeleteDishesProductsURL = `${NewBaseURL}/deleteProduct`;
export const GetEditDishesProductURL = `${NewBaseURL}/getSingleProductList`;
export const EditDishesProductURL = `${NewBaseURL}/updateProduct`;
export const AddNewProductPropertyURL = `${NewBaseURL}/properties`;
export const AddNewPropertyAttributeURL = `${NewBaseURL}/addPropertiesVaule`;
export const DeleteNewPropertyAttributeURL = `${NewBaseURL}/PropertiesVaule`;
export const DeleteProductPropertyURL = `${NewBaseURL}/Property`;
export const AddProductPropertyCombinationPriceURL = `${NewBaseURL}/addCombination`;

/***************************************************************************************/
export const GetAddonGroupListURL = `${NewBaseURL}/getAddonGroup`;
export const CreateAddonGroupURL = `${NewBaseURL}/saveAddon`;
export const UpdateAddonGroupStatusURL = `${NewBaseURL}/addOnStatusUpdate`;
export const UpdateAddonGroupDataURL = `${NewBaseURL}/qtyUpdateOnAddon`;
export const AddonGroupDataItemAddURL = `${NewBaseURL}/addItemsAddon`;
export const DeleteAddonGroupItemURL = `${NewBaseURL}/addonItems`;
export const DeleteAddonGroupURL = `${NewBaseURL}/addongroup`;
export const DeleteAssignAddonGroupURL = `${NewBaseURL}/assignAddonItems`;
export const AssignAddonGroupToProuductURL = `${NewBaseURL}/assignAddon`;
export const SearchProductListForAddonsURL = `${NewBaseURL}/getProductListSearchForAddon`;
/***************************************************************************************/
export const GetCustomersURL = `${NewBaseURL}/getCustomar`;
export const GetCustomersAllURL = `${NewBaseURL}/getAllCustomar`;
export const SearchCustomersURL = `${NewBaseURL}/searchCustomer`;

/***************************************************************************************/
export const GetManageTablesURL = `${NewBaseURL}/getManageTable`;
export const UpdateManageTableNameURL = `${NewBaseURL}/updateTable`;
export const UpdateQrEnableURL = `${NewBaseURL}/updateQr`;
export const GetManageTableCategoryURL = `${NewBaseURL}/getTableCategory`;
export const AddManageTableCategoryURL = `${NewBaseURL}/addTableCategory`;
export const AddManageTableURL = `${NewBaseURL}/addTable`;
export const UpdateTableCategoryStatusURL = `${NewBaseURL}/updateTableCategoryStatus`;
export const DeleteTableCategoryURL = `${NewBaseURL}/deleteTableCategory`;

export const getQrImgaeUrl = `${NewBaseURL}/getQrImgae`;




/***************************************************************************************/
export const GetOrdersURL = `${NewBaseURL}/getOrder`;
export const GetOrderDetailsURL = `${NewBaseURL}/getOrderDetails`;
export const getDishForOrderEdit = `${NewBaseURL}/getDishForOrderEdit`;
export const orderEdit = `${NewBaseURL}/orderEdit`;


export const GetOrderKOTDetailsURL = `${NewBaseURL}/kotDetailsByOrderId`;
export const GetOrderBillsDetailsURL = `${NewBaseURL}/billsDetailsByOrderId`;

export const GetOrderCopounDetailsURL = `${NewBaseURL}/getOrderCopounReportDetails`;

export const GetAllCouponCondName = `${NewBaseURL}/GetAllCouponCondName`;






export const CancelOrderURL = `${NewBaseURL}/cancelledReason`;

/***************************************************************************************/
export const GetLiveOrdersURL = `${NewBaseURL}/getLiveOrder`;
export const GetProductListURL = `${NewBaseURL}/getProductList`;
export const SearchProductListURL = `${NewBaseURL}/getProductListSearch`;
export const UpdateLiveOrdersStatusURL = `${NewBaseURL}/updateLiveOrderAction`;
export const DeleteLiveOrderItemURL = `${NewBaseURL}/deleteItems`;
export const ApplyLiveOrderDiscountURL = `${NewBaseURL}/applyDiscount`;
export const UpdateLiveOrderPaymentURL = `${NewBaseURL}/applyPayment`;
export const LiveOrderNewPaymentURL = `${NewBaseURL}/liveOrderNewPayment`;
export const orderSplitBillCreationURL = `${NewBaseURL}/orderSplitBillCreation`;

export const LiveOrderDuePaymentSubmitURl = `${NewBaseURL}/liveOrderDuePaymentSubmit`;

export const paymentMethodChangeURl = `${NewBaseURL}/paymentMethodChange`;



export const UpdateLiveOrderQuantityURL = `${NewBaseURL}/updateQuantity`;
export const AddNewItemInLiveOrderURL = `${NewBaseURL}/newItemAdd`;
export const checkKotStatusURL = `${NewBaseURL}/checkKotStatus`;

export const clearOrderTableURL = `${NewBaseURL}/clearOrderTableURL`;
export const clearBookedTableURL = `${NewBaseURL}/clearBookedTableURL`;
export const clearKotTableURL = `${NewBaseURL}/clearKotTableURL`;





/***************************************************************************************/
export const GetQRCodeSettingsURL = `${NewBaseURL}/getQrCode`;
export const UpdateQRCodeSettingsURL = `${NewBaseURL}/saveQrCode`;

/***************************************************************************************/
export const GetFoodersCPDetailsURL = `${NewBaseURL}/getFoodersCp`;
export const UpdateFoodersCPDetailsURL = `${NewBaseURL}/updateFooderCp`;

/***************************************************************************************/
export const GetOnlineDeliverySettingsURL = `${NewBaseURL}/getOnlineDelivery`;
export const AddOnlineDeliverySettingsURL = `${NewBaseURL}/saveOnlineDelivery`;
export const DeleteOnlineDeliverySettingsURL = `${NewBaseURL}/deleteOnlineDelivery`;

/***************************************************************************************/
export const GetStaffListURL = `${NewBaseURL}/getStaff`;
export const SearchStaffURL = `${NewBaseURL}/searchStaff`;
export const GetStaffTypeListURL = `${NewBaseURL}/getStaffTypeList`;
export const AddStaffURL = `${NewBaseURL}/saveStaff`;

export const AddStaffRoleURL = `${NewBaseURL}/saveStaffRole`;
export const UpdateStaffRoleURL = `${NewBaseURL}/updateStaffRole`;

export const getStaffProfileDetailUrl = `${NewBaseURL}/getStaffProfileDetail`;

export const updateStaffDetailsUrl = `${NewBaseURL}/updateStaffProfileDetails`;
export const getStaffTypeListUrl = `${NewBaseURL}/getStaffTypeList`;






export const DeleteStaffURL = `${NewBaseURL}/deleteStaff`;
export const UpdateStaffStatusURL = `${NewBaseURL}/staffStatusUpdate`;
export const GetStaffDetailsURL = `${NewBaseURL}/getsingleStaff`;
export const UpdateStaffDetailsURL = `${NewBaseURL}/updateStaff`;
export const UpdateStaffPasswordURL = `${NewBaseURL}/staffPasswordUpdate`;
export const GetAssignTablesDataForStaffURL = `${NewBaseURL}/getAllTable`;
export const AddAssignTablesForStaffURL = `${NewBaseURL}/addNewAssignTableToStaff`;

/***************************************************************************************/


export const orderWwhatssappMmassageHistoryURL = `${NewBaseURL}/orderWhatssappMmassageHistory`;
export const getOrderWhatsappMessageHistoryURL = `${NewBaseURL}/getOrderWhatsappMessageHistory`;








/***************************************************************************************/
export const GetVerificationDetailsURL = `${NewBaseURL}/getVerificationDetails`;
export const AddVerificationDetailsURL = `${NewBaseURL}/saveVerificationDetails`;

/***************************************************************************************/
export const UpdateProductVariantsURL = `${NewBaseURL}/updateVariants`;
export const AddNewProductVariantURL = `${NewBaseURL}/addVariants`;
export const UpdateSingleProductVariantURL = `${NewBaseURL}/updateSingleVariant`;
export const DeleteProductVariantURL = `${NewBaseURL}/deleteSingleVariant`;

/***************************************************************************************/
export const GetRawMaterialUnitListURL = `${NewBaseURL}/listRawMaterialsDetails`;
export const AddRawMaterialURL = `${NewBaseURL}/rawMaterials`;
export const GetRawMaterialListURL = `${NewBaseURL}/rawMaterials`;
export const DeleteRawMaterialURL = `${NewBaseURL}/deleteRawMaterials`;
export const UpdateRawMaterialURL = `${NewBaseURL}/rawMaterials`;
export const UpdateRawMaterialStatusURL = `${NewBaseURL}/updateStatus`;
export const GetSingleRawMaterialURL = `${NewBaseURL}/singleRawMaterials`;

/***************************************************************************************/
export const GetSuppliersListURL = `${NewBaseURL}/suppliers`;
export const AddSupplierURL = `${NewBaseURL}/suppliers`;
export const DeleteSupplierURL = `${NewBaseURL}/deleteSuppliers`;
export const UpdateSupplierStatusURL = `${NewBaseURL}/updateSupplierStatus`;
export const UpdateSupplierURL = `${NewBaseURL}/suppliers`;
export const GetRawMaterialListForSuppliersURL = `${NewBaseURL}/listRawMaterials`;
export const GetSingleSupplierURL = `${NewBaseURL}/singleSuppliers`;

/***************************************************************************************/
export const GetProductAndVariantsURL = `${NewBaseURL}/selectList`;
export const AddRecipeURL = `${NewBaseURL}/saveDishRecipes`;
export const GetAllRecipesListURL = `${NewBaseURL}/getDishRecipes`;
export const GetSingleRecipeURL = `${NewBaseURL}/getSingleDishRecipes`;
export const UpdateRecipeURL = `${NewBaseURL}/updateDishRecipes`;
export const DeleteRecipeURL = `${NewBaseURL}/deleteDishRecipes`;
export const UpdateRecipeStatusURL = `${NewBaseURL}/updateDishRecipesStatus`;
export const UpdateRecipeItemURL = `${NewBaseURL}/updateDishRecipesItem`;
export const AddRecipeItemURL = `${NewBaseURL}/addDishRecipesItems`;
export const DeleteRecipeItemURL = `${NewBaseURL}/deleteFromFrontEndDishRecipesItem`;

/***************************************************************************************/
export const GetAllStockListURL = `${NewBaseURL}/getStock`;

/***************************************************************************************/
export const GetSupplierAndRawMaterialListURL = `${NewBaseURL}/getSupplierAndRawMaterialList`;
export const GetInvoiceListURL = `${NewBaseURL}/purchaseOrder`;
export const GetSingleInvoiceDataURL = `${NewBaseURL}/singlePurchaseOrder`;
export const CreateInvoiceURL = `${NewBaseURL}/purchaseOrder`;
export const UpdateInvoiceURL = `${NewBaseURL}/updatePurchaseOrder`;
export const DeleteInvoiceURL = `${NewBaseURL}/deletePurchaseOrder`;
export const DeleteInvoiceItemURL = `${NewBaseURL}/deletePurchaseOrderItem`;
export const AddInvoiceItemURL = `${NewBaseURL}/purchaseOrderItem`;
export const UpdateInvoiceItemURL = `${NewBaseURL}/updatePurchaseItem`;
export const ApproveInvoiceURL = `${NewBaseURL}/calculatePurchaseOrder`;
export const PaymentInvoiceURL = `${NewBaseURL}/purchasePayment`;

/***************************************************************************************/
export const SearchPurchaseOrderURL = `${NewBaseURL}/getPurchaseOrderListSearch`;
export const GetPurchaseReturnListURL = `${NewBaseURL}/getPurchaseReturn`;
export const GetPurchaseReturnNumberURL = `${NewBaseURL}/getPR`;
export const DeletePurchaseReturnURL = `${NewBaseURL}/deletePurchaseReturn`;
export const ApprovePurchaseReturnURL = `${NewBaseURL}/calculatePurchaseOrderReturnStock`;
export const CreatePurchaseReturnURL = `${NewBaseURL}/savePurchaseOrderReturn`;
export const GetSinglePurchaseReturnDataURL = `${NewBaseURL}/singlePurchaseReturn`;

/***************************************************************************************/
export const GetCouponCodeListURL = `${NewBaseURL}/couponCode`;
export const AddCouponCodeURL = `${NewBaseURL}/couponCode`;
export const UpdateCouponCodeURL = `${NewBaseURL}/couponCode`;
export const UpdateCouponCodeStatusURL = `${NewBaseURL}/updateStatusCouponCode`;
/***************************************************************************************/
export const GetGSTReportURL = `${NewBaseURL}/gstReport`;
export const GetReportByOrderTypeURL = `${NewBaseURL}/orderReport`;
export const GetReportByPaytmentTypeURL = `${NewBaseURL}/paymentTypeReport`;
export const GetReportByNcOrderReportURL = `${NewBaseURL}/ncOrderReport`;


export const GetSalesReportDailyURL = `${NewBaseURL}/salesReportDaily`;
export const getSettledUnsettledReportDailyURL = `${NewBaseURL}/getSettledUnsettledReportDaily`;

export const GetCustomisedSalesReportURL = `${NewBaseURL}/customisedSalesReport`;

export const GetItemsReportURL = `${NewBaseURL}/getItemsReportDetails`;
export const GetStaffList = `${NewBaseURL}/getStaffList`;
export const GetStaffOrderReport = `${NewBaseURL}/getStaffOrderReport`;
export const GetTableList = `${NewBaseURL}/getTableList`;


export const GetHoldOrderReportURL = `${NewBaseURL}/getHoldOrderReport`;





/***************************************************************************************/
export const createRazorpayPayOrderId = `${NewBaseURL}/createRazorpayOrder`;



/***************************************************************************************/
export const GetFoodersPlans = `${NewBaseURL}/getFoodersPlans`;
export const GetFoodersPlansPrice = `${NewBaseURL}/getFoodersPlansPrice`;
export const GetFoodersPlansDetails = `${NewBaseURL}/getFoodersPlansDetails`;

export const GetActivePlans = `${NewBaseURL}/GetActivePlans`;

export const updateFoodersPlans = `${NewBaseURL}/updateFoodersPlans`;

export const applyCouponUrl = `${NewBaseURL}/applyCoupon`;
export const systemIsMaintenanceUrl = `${NewBaseURL}/systemIsMaintenance`;

export const adminControlleDashboardURl = `${NewBaseURL}/adminControlleDashboard`;
export const adminDashboardSellingUrl = `${NewBaseURL}/adminDashboardSelling`;


export const adminDashboardPieChartUrl = `${NewBaseURL}/adminDashboardPieChart`;

export const paymentStatusPieChartUrl = `${NewBaseURL}/paymentStatusPieChart`;
export const cancelStatusPieChartUrl = `${NewBaseURL}/cancelStatusPieChart`;
export const orderTypePieChartUrl = `${NewBaseURL}/orderTypePieChart`;








export const OrderAcceptTime = 60;
export const defaultWhatsappApiAccessToken = "IHlgpnIRbO074tivfBVynec7bleaZRejOmM4tkihNwwETIbOjsdN8WwBukVJOVi9"; // For "Default Whatsapp Api Access Token"
export const vayureachLink = "https://vayureach.com"; // For "vayureach Link"

export const razorpayCheckout = "https://checkout.razorpay.com/v1/checkout.js"; // For "razorpay Link"
// export const razorpay_id = "rzp_test_7PxVYvPD65JMcD"; // For "razorpay Link"
// export const razorpay_id = "rzp_test_RV9IqU9apohNFN"; // For "razorpay Link"
// export const razorpay_id = "rzp_test_SdLMCrcojY62q4"; // For "razorpay Link"

export const staffPosUrl = `http://staff.vyfoo.com`;
export const razorpay_id = "rzp_live_l3PLTMuk8Qvm90"; // For "razorpay Link"



// export const vayureachWhatsappMarketingpdf = "https://images.scanka.com/pdf/VayureachWhatsappMarketing.pdf"; // For "vayureach Whatsapp Marketing pdf Link"



